import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Icon, type IDropdownItem, Typography } from 'shared/ui'
import { PhoneRenderContent } from 'entities/Phone'
import { Inbox } from 'entities/Inbox/model/Inbox'
import { type ISendFromStoreItem } from 'widgets/SendFrom/store/type'
import styles from './styles.module.scss'

export type INumbersInboxesPickerButtonInnerContentProps = {
  item: IDropdownItem<ISendFromStoreItem> | null
  showNumbersCount?: boolean
  hideNumbers?: boolean
  triggerInnerContentClassName?: string
}

export const SendFromTriggerInnerContent: FC<INumbersInboxesPickerButtonInnerContentProps> =
  observer(
    ({ item, showNumbersCount = false, hideNumbers = false, triggerInnerContentClassName }) => {
      const data = item?.data
      const inbox = data?.inbox
      const numbersCount = inbox instanceof Inbox ? inbox?.numbers?.length : 0

      return (
        <>
          <div className={styles.icon}>
            {data?.parentIcon && <Icon icon={data.parentIcon} />}
            {!data?.parentIcon && <Icon icon={item?.iconL || 'inboxOpen'} />}
          </div>

          <div className={classNames(styles.info, triggerInnerContentClassName)}>
            {item ? (
              <Typography
                ariaLabel={'phone'}
                color={'var(--content-primary-primary)'}
                variant={'body-md-regular'}
                ellipsis
              >
                {data?.parentLabel || item.label}
              </Typography>
            ) : (
              <Typography
                color={'var(--content-neutral-primary)'}
                variant={'body-md-regular'}
                ariaLabel={'placeholder'}
              >
                Select Inbox
              </Typography>
            )}

            {data && !hideNumbers && !data.noLabelInfo && (
              <div className={styles.number}>
                <div className={styles.number__point}>
                  <Icon fontSize={2} icon={'ellipse_6'} />
                </div>
                <Typography
                  ariaLabel={'phone'}
                  variant={'body-md-regular'}
                  color={'tertiary'}
                  ellipsis
                >
                  {data?.smart_option_label ||
                    data.mergeField?.name ||
                    (showNumbersCount && numbersCount > 1
                      ? `${numbersCount} numbers`
                      : data.number && <PhoneRenderContent phone={data.number} />)}
                </Typography>
              </div>
            )}
          </div>
        </>
      )
    }
  )
